import RecordsControls from "./RecordsControls";
import RecordsUpload from "./RecordsUpload";

export default function RecordsUploadContainer({practiceitem, managingAttyId, userToken, activeCase, docType, forWorkQ}) {
    const visibleMrqUpload = (() => {
        const mrqUpload = practiceitem?.mrq_upload

        if (!mrqUpload) {
            return null
        }

        const isProcoDoc = mrqUpload?.case_attorney_id !== undefined && mrqUpload?.case_attorney_id !== null
        if (isProcoDoc) {
            return Number(mrqUpload.case_attorney_id) === Number(managingAttyId) ? mrqUpload : null
        }

        return managingAttyId ? null : mrqUpload
    })()

    return <>
        {practiceitem && <>
            {visibleMrqUpload && <>
                <RecordsControls userToken={userToken} activeCase={activeCase} item={visibleMrqUpload} docType={docType} practiceItem={practiceitem} forWorkQ={forWorkQ} managingAttyId={managingAttyId}/>    
            </>}  
            {!visibleMrqUpload && <RecordsUpload practiceId={practiceitem.practice_id} managingAttyId={managingAttyId} practiceItem={practiceitem} activeCase={activeCase} forWorkQ={forWorkQ}/>}          
        </>}
    </>
}